import {headerBundle} from '../features/header-bundle';

const sections = [];

class ProductBundleBuilder {
  constructor(section) {
    if( window.location.search.indexOf(`view=bundle`) === -1 ) {
      return;
    }

    this.section = section;
    this.container = section.container;


    this.bundleProductMapping = {};

    const productBundleJSON = this.container.querySelector(`[data-product-bundle-mapping]`);
    if (productBundleJSON && productBundleJSON.innerHTML !== '') {
      this.bundleProductMapping = JSON.parse(productBundleJSON.innerHTML);
    } else {
      console.error('Missing product bundle mapping JSON');
    }

    this.bundleDiscount = parseInt( this.container.getAttribute(`data-bundle-discount`) ) || 0;
    console.log({
      'bundleProductMapping': this.bundleProductMapping,
      'bundleDiscount': this.bundleDiscount
    });

    this.init();
    this.productSection();
    this.updateSwatchUrls();
    this.hideSections();


    document.querySelector(`.product-section .wrapper`).insertAdjacentHTML('afterbegin', `
      <div bundle-progress-bar-mobile></div>
    `);
    headerBundle();

    // this.hideRebuyCart();
  }

  init() {
    document.addEventListener(
      'theme:cart:added:success',
      function () {
        this.hideRebuyCart();
        const productHandle =  window.location.pathname.replace('/products/', '');
        let targetUrl = `/products/${this.bundleProductMapping[productHandle]}?view=bundle`;
        if( typeof( this.bundleProductMapping[productHandle] ) === 'undefined' ) {
          targetUrl = `/products/infant-lounger-cover-natural?view=bundle`;
          if( location.pathname.indexOf( `infant-lounger-` ) !== -1 ) {
            targetUrl = `/products/infant-lounger-cover-natural?view=bundle`;
          }
          if( location.pathname.indexOf( `toddler-lounger-` ) !== -1 ) {
            targetUrl = `/products/toddler-lounger-cover-natural?view=bundle`;
          }
          if( location.pathname.indexOf( `infant-lounger-cover-` ) !== -1 ) {
            const productHandle = location.pathname.replace(`/products/`, ``);
            targetUrl = `/cart?view=bundle&product=${productHandle}`;
            // targetUrl = `/pages/bundle-builder?step=complete&product=${productHandle}`;
          }
          if( location.pathname.indexOf( `toddler-lounger-cover-` ) !== -1 ) {
            const productHandle = location.pathname.replace(`/products/`, ``);
            targetUrl = `/cart?view=bundle&product=${productHandle}`;
            // targetUrl = `/pages/bundle-builder?step=complete&product=${productHandle}`;
          }
        }

        window.location.href = targetUrl;
      }.bind(this)
    );
  }

  productSection() {
    this.container.querySelectorAll(`[data-add-to-cart-text]`).forEach( btn => {
      // btn.innerHTML = (this.bundleDiscount > 0 ) ? `${theme.strings.product.addToBundleAndSave} ${this.bundleDiscount}%` : `${theme.strings.product.addToBundle}`;
      btn.innerHTML = `Select`
      if( location.pathname.indexOf( `-lounger-` ) !== -1 ) {
        btn.innerHTML = `Select Lounger`
      }
      if( location.pathname.indexOf( `-cover-` ) !== -1 ) {
        const productHandle = location.pathname.replace(`/products/`, ``);
        btn.innerHTML = `Select Cover`
      }
    });
    this.container.querySelectorAll(`.breadcrumb`).forEach( section => {
      section.style.visibility = 'hidden';
    });
    document.querySelectorAll(`.product__button__babylist`).forEach( section => {
      section.style.display = 'none';
    });
    document.querySelectorAll(`[data-quantity-selector]`).forEach( section => {
      section.style.display = 'none';
    });
  }

  hideRebuyCart() {
    if( document.querySelector(`#rebuy-cart`) === null ) {
      return;
    }
    document.querySelector(`#rebuy-cart`).style.visibility = 'hidden';
  }

  hideSections() {
    document.querySelectorAll(`.main-content .shopify-section`).forEach( section => {
      section.style.display = 'none';
    });
    this.container.closest(`.shopify-section`).style.display = 'block';
    this.container.querySelectorAll(`.product__tabs`).forEach( section => {
      section.style.display = 'none';
    });
  }

  updateSwatchUrls() {
    this.container.querySelectorAll(`.swatch__button`).forEach( ele => {
      let url = ele.getAttribute(`href`);
      url += (url.indexOf(`?`) === -1) ? `?view=bundle` : `&view=bundle`;
      ele.setAttribute(`href`, url);
    });
  }
}

const productBundleBuilder = {
  onLoad() {
    sections[this.id] = new ProductBundleBuilder(this);
  },
  onUnload: function () {
    if (typeof sections[this.id].unload === 'function') {
      sections[this.id].unload();
    }
  },
};

export {productBundleBuilder};
